module.exports = "/virtual-football-league/img/video/clubs/france/bordeaux.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/france/bordeaux.png
// module id = 338
// module chunks = 4